"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.alphaMixin = void 0;
var _styledToken = _interopRequireDefault(require("styled-token"));
var _hexToAlpha = require("../util/hexToAlpha");
/** @mixin alphaMixin */
/**
 * Applies an alpha value to one of the Constellation colors, returns the value in `rgba()` format
 *
 * @example
 * import { alphaMixin } from '@zillow/constellation';
 *
 * const Component = styled.div`
 *     color: ${alphaMixin('caution', 0.5)};
 * `;
 *
 * <Component />
 *
 * @method
 * @param {string} key - Key should be one of the values defined in `colors`.
 * @param alpha - Alpha value should be an integer in [0,255], a float in [0,1],
 *     or a 1 to 2 character hex value in the [0,255] range.
 * @return {CSSObject}
 */
var alphaMixin = function alphaMixin(key, alpha) {
  return (0, _styledToken.default)('colors', function (colors) {
    var toParse = colors[key];
    if (!toParse || typeof toParse !== 'string') {
      throw new Error("Unknown color '" + key + "'");
    }
    return (0, _hexToAlpha.hexToAlpha)(toParse, alpha);
  });
};
exports.alphaMixin = alphaMixin;